import { useQuery } from '@tanstack/react-query'

import { type UniformActor } from '@aeris/uniforms'

import { fetchUniformViewer } from './api/uniforms.ts'

/**
 * Quem está olhando a produção: se gerencia e quais funções tem (F171).
 *
 * É o que a tela usa para desabilitar o que não é da pessoa — com as MESMAS
 * funções de `@aeris/uniforms` que o servidor usa para recusar. Enquanto a
 * resposta não chega, ninguém mexe em nada: melhor um botão que acende meio
 * segundo depois do que um que acende e toma 403.
 */
export const useUniformViewer = (): {
  readonly actor: UniformActor
  readonly userId: string | null
  readonly ready: boolean
} => {
  const query = useQuery({
    queryKey: ['uniform-viewer'],
    queryFn: async ({ signal }) => await fetchUniformViewer(signal),
    staleTime: 60_000,
  })
  return {
    actor: {
      manages: query.data?.manages ?? false,
      functions: query.data?.functions ?? [],
    },
    userId: query.data?.userId ?? null,
    ready: query.data !== undefined,
  }
}
